var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#chevron-right-right',
                        view: publicPath + 'sprite.svg#view-chevron-right-right',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/chevron-right-right.svg
// module id = 405
// module chunks = 0